import { motion } from 'framer-motion';
import image from './../images/web/bio.webp';

const Biography = () => {
   const fadeInUp = {
      initial: { opacity: 0, y: 40 },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true },
      transition: { duration: 0.8 },
   };

   return (
      <div>
         {/* Hero Section */}
         <div style={styles.hero} className="subpage-hero">
            <motion.div
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ duration: 1 }}
               style={styles.heroOverlay}
            >
               <motion.h1
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  style={styles.heroTitle}
               >
                  Biography
               </motion.h1>
            </motion.div>
         </div>

         {/* Introduction Section */}
         <section style={styles.section}>
            <div style={styles.container}>
               <div style={styles.introGrid}>
                  <motion.div {...fadeInUp} style={styles.introImageWrapper}>
                     <img src={image} alt="피아니스트 김예라 프로필 사진" style={styles.introImage} />
                  </motion.div>
                  <motion.div {...fadeInUp} style={styles.introContent}>
                     <div style={styles.divider} />
                     <p style={styles.introParagraph}>
                        섬세한 테크닉과 다채로운 표현력을 선보이고 있는 피아니스트 김예라는 선화예술중·고등학교를 졸업하고
                        중앙대학교 음악대학을 성적우수로 졸업하였다.
                     </p>
                     <p style={styles.introParagraph}>
                        이후 도미하여 텍사스 베일러대학교 음악대학 (Baylor University)에서 석사과정을 (Master of Music)
                        만점으로 졸업한 후 펜실베니아 주립대학교 (Pennsylvania State University)에서 프랑스 현대 작곡가
                        Andre Jolivet의 피아노 문헌 및 음악적 표현에 관한 논문으로 피아노 연주전공 박사학위
                        (Doctor of Musical Arts)를 취득하여 전문 연주자로서 갖춰야 할 탄탄한 기반을 마련하였다.
                     </p>
                     <p style={styles.introParagraph}>
                        유학시절부터 음악적 학업에 두각을 나타낸 그녀는 텍사스 베일러대학교 재학 시 음악대학 교수들의
                        만장일치로 Roger L. Keys Award 학장상을 수상하였으며 전액 장학생으로 선정되었다.
                     </p>
                  </motion.div>
               </div>
            </div>
         </section>

         {/* Achievements Section */}
         <section style={styles.sectionDark}>
            <div style={styles.container}>
               <motion.div {...fadeInUp} style={styles.sectionHeader}>
                  <h2 style={styles.sectionTitle}>수상 경력</h2>
                  <div style={styles.dividerLight} />
               </motion.div>
               <motion.div {...fadeInUp} style={styles.achievementsGrid}>
                  {achievements.map((item, index) => (
                     <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: index * 0.1 }}
                        style={styles.achievementItem}
                     >
                        <span style={styles.achievementIcon}>★</span>
                        <span style={styles.achievementText}>{item}</span>
                     </motion.div>
                  ))}
               </motion.div>
            </div>
         </section>

         {/* Education Section */}
         <section style={styles.section}>
            <div style={styles.container}>
               <motion.div {...fadeInUp} style={styles.sectionHeader}>
                  <h2 style={styles.sectionTitleDark}>학력</h2>
                  <div style={styles.divider} />
               </motion.div>
               <div style={styles.timelineContainer}>
                  {education.map((item, index) => (
                     <motion.div
                        key={index}
                        initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: index * 0.15 }}
                        style={styles.timelineItem}
                     >
                        <div style={styles.timelineDot} />
                        <div style={styles.timelineContent}>
                           <h3 style={styles.timelineTitle}>{item.title}</h3>
                           <p style={styles.timelineDescription}>{item.description}</p>
                        </div>
                     </motion.div>
                  ))}
               </div>
            </div>
         </section>

         {/* Performances Section */}
         <section style={styles.sectionCream}>
            <div style={styles.container}>
               <motion.div {...fadeInUp} style={styles.sectionHeader}>
                  <h2 style={styles.sectionTitleDark}>주요 연주 경력</h2>
                  <div style={styles.divider} />
               </motion.div>
               <div style={styles.performancesGrid}>
                  {performances.map((item, index) => (
                     <motion.div
                        key={index}
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        style={styles.performanceCard}
                     >
                        <p style={styles.performanceText}>{item}</p>
                     </motion.div>
                  ))}
               </div>
            </div>
         </section>

         {/* Teaching Section */}
         <section style={styles.section}>
            <div style={styles.container}>
               <motion.div {...fadeInUp} style={styles.sectionHeader}>
                  <h2 style={styles.sectionTitleDark}>강의 경력</h2>
                  <div style={styles.divider} />
               </motion.div>
               <motion.div {...fadeInUp} style={styles.teachingContent}>
                  <p style={styles.teachingText}>
                     김경빈, 황소원, 최영임, Krassimira Jordan, Christopher Guzman을 사사한 그녀는
                     텍사스 베일러대학교에서 반주조교, 펜실베니아 주립대학교에서 음악학부 교양 및 전공필수 강의 강사,
                     부전공 피아노 실기 수업을 진행하였다.
                  </p>
                  <p style={styles.teachingText}>
                     귀국 이후에는 선화예술중학교 및 고등학교, 광주교육대학교, 창의예술고등학교 출강하며,
                     국내에서도 후학에 열성을 다하는 교육자 및 연주자로서 다양한 활동중이다.
                  </p>
               </motion.div>
            </div>
         </section>
      </div>
   );
};

const achievements = [
   'Texas Semper Pro Musica Competition 우승',
   'New York International Music Competition 1등',
   'United States International Music Competition 1등',
   'Art-Rogaska International Music Competition Slovenia-Austria 1등',
   'The American Prize Competition 2등',
   'American Protégé International Piano Competition 2위',
   '한국 영아티스트 음악 콩쿠르 2위',
   'Quebec International Music Competition Platinum 메달 수상',
];

const education = [
   { title: '선화예술중,고등학교', description: '졸업' },
   { title: '중앙대학교', description: '성적우수 졸업 (Cum Laude), 콘체르토 오디션 솔로이스트 선정' },
   { title: '텍사스 베일러대학교', description: '음악학 석사 (M.M) 만점 4.0/4.0 졸업, 전액장학생, Roger L. Keys Award 학장상 수상' },
   { title: '펜실베니아 주립대학교', description: '음악학 박사 (D.M.A), 전액장학생, 음악대학 강사 역임' },
];

const performances = [
   '루마니아 야쉬 필하모닉 오케스트라 협연 (Mozart Piano Concerto No.21)',
   '루마니아 오라데아 필하모닉 오케스트라 협연 (Saint-Saens Piano Concerto No.2)',
   'Carnegie Hall (뉴욕)',
   'Lincoln Memorial (워싱턴 D.C)',
   '국회의원회관 초청연주회',
   '영산아트홀 영아티스트 콘서트',
   '금호아트홀 귀국 독주회',
   '서귀포 예술의 전당 피아노 독주회',
];

const styles = {
   hero: {
      position: 'relative',
      height: '50vh',
      minHeight: '400px',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   heroOverlay: {
      textAlign: 'center',
   },
   heroTitle: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: 'clamp(2.5rem, 8vw, 5rem)',
      fontWeight: 300,
      color: 'white',
      letterSpacing: '0.3em',
      textTransform: 'uppercase',
      margin: 0,
   },
   section: {
      padding: '100px 0',
   },
   sectionDark: {
      padding: '100px 0',
      backgroundColor: '#0a0a0a',
      color: 'white',
   },
   sectionCream: {
      padding: '100px 0',
      backgroundColor: '#f5f0e8',
   },
   container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 5%',
   },
   introGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '60px',
      alignItems: 'start',
   },
   introImageWrapper: {
      position: 'relative',
   },
   introImage: {
      width: '100%',
      height: 'auto',
      display: 'block',
   },
   introContent: {
      paddingTop: '20px',
   },
   divider: {
      width: '60px',
      height: '1px',
      backgroundColor: '#c9a227',
      marginBottom: '30px',
   },
   dividerLight: {
      width: '60px',
      height: '1px',
      backgroundColor: '#c9a227',
      margin: '20px auto 0',
   },
   introParagraph: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '1rem',
      lineHeight: 2,
      color: '#333',
      marginBottom: '20px',
      fontWeight: 300,
   },
   sectionHeader: {
      textAlign: 'center',
      marginBottom: '60px',
   },
   sectionTitle: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: 'clamp(2rem, 4vw, 3rem)',
      fontWeight: 300,
      color: 'white',
      letterSpacing: '0.1em',
      margin: 0,
   },
   sectionTitleDark: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: 'clamp(2rem, 4vw, 3rem)',
      fontWeight: 300,
      color: '#0a0a0a',
      letterSpacing: '0.1em',
      margin: 0,
   },
   achievementsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px',
   },
   achievementItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '20px',
      borderLeft: '2px solid #c9a227',
   },
   achievementIcon: {
      color: '#c9a227',
      fontSize: '1rem',
   },
   achievementText: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.95rem',
      fontWeight: 300,
      lineHeight: 1.6,
   },
   timelineContainer: {
      position: 'relative',
      maxWidth: '800px',
      margin: '0 auto',
   },
   timelineItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '30px',
      marginBottom: '40px',
      position: 'relative',
   },
   timelineDot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: '#c9a227',
      flexShrink: 0,
      marginTop: '8px',
   },
   timelineContent: {
      flex: 1,
   },
   timelineTitle: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#0a0a0a',
      marginBottom: '10px',
   },
   timelineDescription: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.95rem',
      fontWeight: 300,
      color: '#666',
      lineHeight: 1.8,
   },
   performancesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '20px',
   },
   performanceCard: {
      backgroundColor: 'white',
      padding: '30px',
      borderLeft: '3px solid #c9a227',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
   },
   performanceText: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.95rem',
      fontWeight: 300,
      color: '#333',
      lineHeight: 1.6,
      margin: 0,
   },
   teachingContent: {
      maxWidth: '800px',
      margin: '0 auto',
      textAlign: 'center',
   },
   teachingText: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '1rem',
      fontWeight: 300,
      color: '#333',
      lineHeight: 2,
      marginBottom: '20px',
   },
};

export default Biography;
